import { v4 as uuidv4 } from 'uuid';
import React, { useState, useEffect } from 'react';

import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import ReactPaginate from "react-paginate";
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import * as XLSX from 'xlsx';
import '../../../css/tableStyle.css'
import apiClient from '../ApiClient/ApiClient';

export default function Order({data}) {
    const [loading, setLoading] = useState(false);
    const [newData,setNewData] = useState(null);
    
    const [detailData,setDetailData] = useState(null);
    const [model,setModel] = useState('訂單總覽');
    const [page,setPage] = useState(1);
    const workMargin = {
        marginTop: '3%',
        marginBottom:'5%'
    } 
    const [isTaiRih, setIsTaiRih] = useState('台日');
    const [isGiven, setIsGiven] = useState('未交');
    const [filterField, setFilterField] = useState('批號');
    const [sortWay, setSortWay] = useState('批號');
    const [start, setStart] = useState("");
    const [end, setEnd] = useState("");



    const setModelandGetDate = (newModel) =>{
        setModel(newModel);
    }

        // ★★★ 新增：匯出 EXCEL 函式 ★★★
        const handleExportExcel = () => {
            // 1. 取出現在 DataGrid 使用的資料（優先 newData，其次是父層傳進來的 data）
            const list = newData?.orderManages ?? data?.orderManages ?? [];
    
            if (!list || list.length === 0) {
                alert('目前沒有資料可以匯出');
                return;
            }
    
            // 2. 轉成適合 Excel 的 JSON（欄位名稱用你想要的中文抬頭）
            const sheetData = list.map((item, idx) => ({
                序號: idx + 1,
                承製公司: item.company,
                客戶: item.client,
                批號: item.piNum,
                圖號: item.drawNum,
                項次: item.itemNum,
                物品名: item.itemName,
                訂單號碼: item.orderNum,
                流水號: item.orderSerial,
                訂單數量: item.orderAmount,
                單位: item.unit,
                發動數量: item.launchAmount,
                客戶納期: item.clientDate,
                累積交貨: item.accumulation,
                尚未交貨: (item.orderAmount ?? 0) - (item.accumulation ?? 0),
                實交貨日: item.tureTradeDate,
                訂購: item.tradeLocation,
                說明: item.introduce,
                註記代號: item.markNum,
                單價: item.price,
                接收日期: item.receiveDate,
                ID: item.id,
            }));
    
            // 3. 建立工作簿與工作表
            const wb = XLSX.utils.book_new();
            const ws = XLSX.utils.json_to_sheet(sheetData);
    
            XLSX.utils.book_append_sheet(wb, ws, '訂單總覽');
    
            // 4. 產生檔名（可自行調整）
            const today = new Date();
            const yyyy = today.getFullYear();
            const mm = String(today.getMonth() + 1).padStart(2, '0');
            const dd = String(today.getDate()).padStart(2, '0');
            const fileName = `訂單總覽_${yyyy}${mm}${dd}.xlsx`;
    
            // 5. 觸發下載
            XLSX.writeFile(wb, fileName);
        };
        // ★★★ 匯出函式結束 ★★★
    
       
    return(
        <>
        {/* Loading 遮罩 */}
        <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        >
        <CircularProgress color="inherit" />
        </Backdrop>
    
        {/* 主體畫面開始 */}
        <div className='container-fluid'>
            <div className='row'  style={workMargin}>
                <div className='col-5'/>
                <div className='col-2'>
                    <h2><span className="badge bg-success">{model}</span></h2>
                    
                </div>
                <div className='col-5'/>              
            </div>
            
            <div className='row'>
                <div className='col-12'>
                    {model === '訂單總覽'?<h2><span className="badge bg-dark">搜尋條件</span></h2>:null}
                </div>              
            </div>
            <div className='row'>
                <div className='col-12'>
                    {model === '訂單總覽'?<SelectFilter 
                        setNewData={setNewData}
                        
                        isTaiRih={isTaiRih}
                        setIsTaiRih={setIsTaiRih}
                        isGiven={isGiven}
                        setIsGiven={setIsGiven}
                        filterField={filterField}
                        setFilterField={setFilterField}
                        sortWay={sortWay}
                        setSortWay={setSortWay}
                        start={start}
                        setStart={setStart}
                        end={end}
                        setEnd={setEnd}
                        setPage={setPage}
                        setLoading={setLoading} // ✅ 傳進去
                    /> : null}
                    {/* {model === '訂單輸入'?<CreateForm/> : null} */}
                </div>              
            </div>
            <div className='row'>
            <div className='col-12 d-flex align-items-center mb-2'>
                {/* 標籤 */}
                <h2 className="mb-0 me-3">
                <span className="badge bg-dark">{model}</span>
                </h2>

                {/* ★ 新增 EXCEL 按鈕：只有在「訂單總覽」時顯示 ★ */}
                {model === '訂單總覽' && (
                <button
                    type="button"
                    className="btn btn-outline-success"
                    onClick={handleExportExcel}
                    disabled={!(newData?.orderManages?.length || data?.orderManages?.length)}
                >
                    EXCEL
                </button>
                )}
            </div>
            </div>
            <div className='row'>
                <div className='col-12'>
                    {newData != null && model === '訂單總覽'?<ListTable 
                    data={newData || data}
                    setNewData={setNewData}
                    page={page}
                    setPage={setPage}
                    isTaiRih={isTaiRih}
                    isGiven={isGiven}
                    filterField={filterField}
                    sortWay={sortWay}
                    start={start}
                    end={end}
                    setLoading={setLoading} // ✅ 傳進去
                    /> :<div>目前還沒取得資料或取不到資料</div>}
                </div>              
            </div>
        </div>
        </>     
    )
}



function ListTable({ 
    data, setNewData, page, setPage, 
    isTaiRih, isGiven, filterField, sortWay, start, end,setLoading // ✅ 接收 
}) {
    const thStyle = {
        centered: {
            textAlign: 'center',
          }
    }
    const nextPage = async () => {
        setLoading(true);
        try {
            
            const params = {
                isTaiRih,
                isGiven,
                filterField,
                sortWay,
                start,
                end,
                page: page + 1, // 加上頁碼
            };
            
            const response = await apiClient.get(`/OrderManage/GetMains`, { params });
            if (response.data.statusCode === 200 && response.data.orderManages.length > 0) {
                setNewData(response.data);
                setPage(page + 1);
            } else {
                alert('已經是最後一頁');
            }
        } catch (error) {
            console.error('Error fetching next page:', error);
            alert(error.response?.data?.message || '訂單查詢失敗，請稍後重試');
        }finally{
            setLoading(false);
        }
    };


    const prePage = async () => {
        if (page === 1) {
            return; // 如果是第一頁，不執行動作
        }
        setLoading(true);
        try {
            const params = {
                isTaiRih,
                isGiven,
                filterField,
                sortWay,
                start,
                end,
                page: page - 1, // 加上頁碼
            };
            
            const response = await apiClient.get(`/OrderManage/GetMains`, { params });
            if (response.data.statusCode === 200) {
                setNewData(response.data);
                setPage(page - 1);
            } else {
                alert('已經是第一頁');
            }
        } catch (error) {
            console.error('Error fetching previous page:', error);
            alert(error.response?.data?.message || '訂單查詢失敗，請稍後重試');
        }finally{
            setLoading(false);
        }
    };

    const columns = [
        
        { field: 'company', headerName: '承製公司', width: 90 },
        { field: 'client', headerName: '客戶', width: 80 },
        { field: 'piNum', headerName: '批號', width: 110 },
        { field: 'drawNum', headerName: '圖號', width: 120 },
        { field: 'itemNum', headerName: '項次', width: 60 },
        { field: 'itemName', headerName: '物品名', width: 120 },
        { field: 'orderNum', headerName: '訂單號碼', width: 110 },
        { field: 'orderSerial', headerName: '流水號', width: 80 },
        { field: 'orderAmount', headerName: '訂單數量', width: 120 },
        { field: 'unit', headerName: '單位', width: 80 },
        { field: 'launchAmount', headerName: '發動數量', width: 100 },
        { field: 'clientDate', headerName: '客戶納期', width: 100 },
        { field: 'accumulation', headerName: '累積交貨', width: 120 },
        {
          field: 'notYet',
          headerName: '尚未交貨',
          width: 120,
          valueGetter: (params) =>
            (params.row.orderAmount ?? 0) - (params.row.accumulation ?? 0),
        },
        { field: 'postingStatus', headerName: '扣帳狀態', width: 110, editable: false },
        { field: 'tureTradeDate', headerName: '實交貨日', width: 120 },
        { field: 'tradeLocation', headerName: '訂購', width: 80 },
        { field: 'introduce', headerName: '說明', width: 120 },
        { field: 'markNum', headerName: '註記代號', width: 100 },
        { field: 'price', headerName: '單價', width: 100 },
        { field: 'receiveDate', headerName: '接收日期', width: 120 },
        { field: 'id', headerName: 'ID', width: 60 },
      ];

      const rows = (data?.orderManages ?? []).map((item, idx) => ({
        id: item.id ?? idx + 1, // 沒 id 就自動給
        ...item,
      }));

      return (
        <>
          <Box sx={{ height: 600, width: '100%', mt: 2 }}>
            <DataGrid
              rows={rows}
              columns={columns}
              pageSize={50}
              rowsPerPageOptions={[50]}
              hideFooterPagination
              disableRowSelectionOnClick
              getRowId={(row) => row.id}
              rowHeight={30}
              headerHeight={32}
              sx={{ fontSize: 14 }}
              autoHeight={false}
            />
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 2,
              mt: 2,
              mb: 2,
            }}
          >
            <button
              type="button"
              className="btn btn-dark"
              onClick={prePage}
              disabled={page === 1}
            >
              上一頁
            </button>
            <span>目前第 {page} 頁</span>
            <button
              type="button"
              className="btn btn-dark"
              onClick={nextPage}
              disabled={rows.length < 50}
            >
              下一頁
            </button>
          </Box>
        </>
      );
    }

function SelectFilter({
    setNewData, 
     
    isTaiRih, 
    setIsTaiRih, 
    isGiven, 
    setIsGiven, 
    filterField, 
    setFilterField, 
    sortWay, 
    setSortWay, 
    start, 
    setStart, 
    end, 
    setEnd,
    setPage,
    setLoading // ✅ 接收
}) {

    // 放在 SelectFilter 函式內最上面（接在 props 後）
    const endInputRef = React.useRef(null);

    const commitStartToEnd = (val) => {
    setEnd(val ?? "");
    // 自動把游標移到「到」輸入框，方便立刻微調
    endInputRef.current?.focus();
    };
    
    const handleSubmit = async (event) => {
        setLoading(true);
        event.preventDefault();
        // Replace with your actual endpoint
        const RealapiUrl = `/OrderManage/GetMains`;
        const params = {
            isTaiRih,
            isGiven,
            filterField,
            sortWay,
            start,
            end,
        };
        try {
            const response = await apiClient.get(RealapiUrl, { params });
            setNewData(response.data);
            setPage(1);
        } catch (error) {
            console.error('Error fetching order data:', error);
            alert(error.response?.data?.message || '訂單查詢失敗，請稍後重試');
        } finally {
            setLoading(false);
        }
    };
    return(
        <form onSubmit={handleSubmit}>
        <div className='container-fluid'>
            <div className='row'>
                <div className='col-3'>
                    <div className="form-check">
                        <label className="form-check-label" htmlFor="isTaiRih">
                            <input className="form-check-input" type="radio" name="isTaiRih" id="isTaiRih1" checked={isTaiRih === '台日'} onChange={() => setIsTaiRih('台日')}/>                       
                                台日
                        </label>
                        </div>
                    <div className="form-check">
                        <label className="form-check-label" htmlFor="isTaiRih">
                            <input className="form-check-input" type="radio" name="isTaiRih" id="isTaiRih2" checked={isTaiRih === '其它'} onChange={() => setIsTaiRih('其它')}/>                       
                            其它
                        </label>
                    </div>                 
                </div>
                <div className='col-3'>
                    <div className="form-check">
                        <label className="form-check-label" htmlFor="isGiven">
                            <input className="form-check-input" type="radio" name="isGiven" id="isGiven1" checked={isGiven === '全部'} onChange={() => setIsGiven('全部')}/>                       
                               全部
                        </label>
                        </div>
                    <div className="form-check">
                        <label className="form-check-label" htmlFor="isGiven">
                            <input className="form-check-input" type="radio" name="isGiven" id="isGiven2" checked={isGiven === '未交'} onChange={() => setIsGiven('未交')}/>                       
                                未交
                        </label>
                    </div>
                </div>
                <div className='col-3'>
                    過濾
                    <div className="form-check">
                        <label className="form-check-label" htmlFor="filterField">
                            <input className="form-check-input" type="radio" name="filterField" id="filterField1" checked={filterField === '批號'} onChange={() => setFilterField('批號')}/>                       
                                批號
                        </label>
                        </div>
                    <div className="form-check">
                        <label className="form-check-label" htmlFor="filterField">
                            <input className="form-check-input" type="radio" name="filterField" id="filterField2" checked={filterField === '客戶納期'} onChange={() => setFilterField('客戶納期')}/>                       
                            客戶納期
                        </label>
                    </div>
                    <div className="form-check">
                        <label className="form-check-label" htmlFor="filterField">
                            <input className="form-check-input" type="radio" name="filterField" id="filterField3" checked={filterField === '機種'} onChange={() => setFilterField('機種')}/>                       
                            機種
                        </label>
                    </div>
                    <div className="form-check">
                        <label className="form-check-label" htmlFor="filterField">
                            <input className="form-check-input" type="radio" name="filterField" id="filterField4" checked={filterField === '圖號'} onChange={() => setFilterField('圖號')}/>                       
                            圖號
                        </label>
                    </div>
                    <div className="form-check">
                        <label className="form-check-label" htmlFor="filterField">
                            <input className="form-check-input" type="radio" name="filterField" id="filterField5" checked={filterField === '訂單號碼'} onChange={() => setFilterField('訂單號碼')}/>                       
                            訂單號碼
                        </label>
                    </div>
                </div>
                <div className='col-3'>
                    排序
                    <div className="form-check">
                        <label className="form-check-label" htmlFor="sortWay">
                            <input className="form-check-input" type="radio" name="sortWay" id="sortWay1" checked={sortWay === '批號'} onChange={() => setSortWay('批號')}/>                       
                                批號
                        </label>
                        </div>
                    <div className="form-check">
                        <label className="form-check-label" htmlFor="sortWay">
                            <input className="form-check-input" type="radio" name="sortWay" id="sortWay2" checked={sortWay === '客戶納期'} onChange={() => setSortWay('客戶納期')}/>                       
                            客戶納期
                        </label>
                    </div>
                    <div className="form-check">
                        <label className="form-check-label" htmlFor="sortWay">
                            <input className="form-check-input" type="radio" name="sortWay" id="sortWay3" checked={sortWay === '納期+圖號+批號'} onChange={() => setSortWay('納期+圖號+批號')}/>                       
                            納期+圖號+批號
                        </label>
                    </div>
                    <div className="form-check">
                        <label className="form-check-label" htmlFor="sortWay">
                            <input className="form-check-input" type="radio" name="sortWay" id="sortWay4" checked={sortWay === '圖號'} onChange={() => setSortWay('圖號')}/>                       
                            圖號
                        </label>
                    </div>
                    <div className="form-check">
                        <label className="form-check-label" htmlFor="sortWay">
                            <input className="form-check-input" type="radio" name="sortWay" id="sortWay5" checked={sortWay === '訂單號碼'} onChange={() => setSortWay('訂單號碼')}/>                       
                            訂單號碼
                        </label>
                    </div>
                    <div className="form-check">
                        <label className="form-check-label" htmlFor="flexRadioDefault2">
                            <input className="form-check-input" type="radio" name="sortWay" id="sortWay6" checked={sortWay === '機種'} onChange={() => setSortWay('機種')}/>                       
                            機種
                        </label>
                    </div>
                </div>
            </div>
            <div className='row mb-3'>
                <div className='col-6'>
                    <label htmlFor="inputText1">從
                    <input
                        type="text"
                        className="form-control"
                         id="inputText1"
                        value={start}
                        onChange={(e) => setStart(e.target.value)}
                        onKeyDown={(e) => {
                        // 避免中文輸入法組字時 Enter 被誤觸
                        if (e.key === "Enter" && !e.nativeEvent.isComposing) {
                            commitStartToEnd(e.currentTarget.value);
                        }
                        }}
                        onBlur={() => {
                        // 只有在「到」目前是空的時候才自動帶入，避免覆蓋使用者已填的內容
                        if (!end) commitStartToEnd(start);
                        }}
                    />
                    </label>
                </div>
                <div className='col-6'>
                    <label htmlFor="inputText2">到
                    <input ref={endInputRef} type="text" className="form-control" id="inputText2" value={end} onChange={(e) => setEnd(e.target.value)} onFocus={() => {
    // 使用者跳到「到」欄位時，如果目前是空白，就先帶入「從」
    if (!end) setEnd(start);
  }}/>
                    </label>
                </div>
            </div>
            <div className='row' style={{ textAlign: 'center' }}>
                <div className='col-12'>
                    <button type="submit" className="btn btn-dark" onClick={handleSubmit}>提交</button>
                </div>
            </div>
        </div>      
  </form>
    )
}



function CreateForm() {

    const [selectValue, setSelectValue] = useState("");
    const [selectCom, setSelectCom] = useState("福蒙");
    const [newPinum, setNewPinum] = useState("");
    const [options, setOptions] = useState([]);
    const [formData, setFormData] = useState({
        client: '',
        receiveDate: '',
        orderNum: ''
        // 更多的字段...
    });


    const handleSelectChange = (event) => {
        setSelectValue(event.target.value);
    }
    const today = new Date(); 
    const randomCode = Math.floor(1000 + Math.random() * 9000);
    const variable = `-${randomCode}`;
    const formattedToday = today.getFullYear().toString().slice(-2) + (today.getMonth() + 1).toString().padStart(2, '0') + today.getDate().toString().padStart(2, '0') + variable;
    const hahatoday = today.getFullYear() + (today.getMonth() + 1).toString().padStart(2, '0') + today.getDate().toString().padStart(2, '0');

    
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await apiClient.get(`/OrderManage/GetOptions`);
                setOptions(response.data);
            } catch (error) {
                console.error('Failed to fetch data', error);
            }
        };

        fetchData();
    }, []);  

    const setNewPinumLot = () => {
        setNewPinum(formattedToday);
    }

    const handleInsertSubmit = async (event) => {
        event.preventDefault();
        if(selectValue === '')
        {
            alert('請選擇客戶')
        }
        else
        {
            formData.client= selectValue;
            formData.receiveDate = hahatoday;
            formData.orderNum = newPinum;
            formData.piNum = newPinum;
            formData.company = selectCom;
            
            try {
                // 使用你的API URL
                const response = await apiClient.post(`/OrderManage/CreateMain`, formData);
                if (response.status === 200) {
                    // 处理响应
                    console.log('Data successfully submitted');
                }
            } catch (error) {
                console.error('There was an error!', error);
            }
        }

    };
    const handleInputChange = (event) => {
        const { id, value } = event.target;
        setFormData(prevState => ({
            ...prevState,
            [id]: value
        }));
    };
    return(
        <form onSubmit={handleInsertSubmit}>
                        <div className='container-fluid'>
                            <div className='row mb-3'>
                                <div className='col-1 px-0 d-flex align-items-center' style={{textAlign: 'center'}}>
                                    <span>客戶</span>
                                </div>
                                <div className='col-2 ps-0'>
                                <select className="form-select" id="client" value={selectValue} onChange={handleSelectChange}>
                                {options.companyOptions != null?options.companyOptions.map((item, index) => (
                                    <option key={index} value={item.comSimpleName}>
                                        {`${item.comNum}  ${item.comSimpleName}  ${item.comFullName}`}
                                    </option>
                                )):null}                                
                                </select>
                                </div>
                                <div className='col-1 px-0 d-flex align-items-center' style={{textAlign: 'center'}}>
                                    <span>接收日期</span>
                                </div>
                                <div className='col-2  ps-0'>
                                    <input type="text" id="receiveDate" className="form-control" aria-describedby="passwordHelpInline"
                                    value={hahatoday}
                                    onChange={handleInputChange}/>
                                </div>
                                <div className='col-1 px-0 d-flex align-items-center' style={{textAlign: 'center'}}>
                                    <span>訂單號碼</span>
                                </div>
                                <div className='col-2  ps-0'>
                                    <input type="text" id="orderNum" className="form-control" aria-describedby="passwordHelpInline"
                                    value={newPinum}
                                    onChange={handleInputChange}/>
                                </div>
                                <div className='col-1 px-0 d-flex align-items-center' style={{textAlign: 'center'}}>
                                    <span>批號</span>
                                    <button type="button" className="btn btn-light" onClick={setNewPinumLot}>New</button>
                                </div>
                                <div className='col-2  ps-0'>
                                    <input type="text" id="piNum" className="form-control" aria-describedby="passwordHelpInline"
                                    value={newPinum}
                                    onChange={handleInputChange}/>
                                </div>
                            </div>
                            <div className='row mb-3'>
                                <div className='col-1 px-0 d-flex align-items-center' style={{textAlign: 'center'}}>
                                    <span>機種Model</span>
                                </div>
                                <div className='col-2 ps-0'>
                                    <input type="text" id="model" className="form-control" aria-describedby="passwordHelpInline"
                                    onChange={handleInputChange}/>
                                </div>
                                <div className='col-1 px-0 d-flex align-items-center' style={{textAlign: 'center'}}>
                                    <span>數量Qty</span>
                                </div>
                                <div className='col-2  ps-0'>
                                    <input type="text" id="qty" className="form-control" aria-describedby="passwordHelpInline"
                                    onChange={handleInputChange}/>
                                </div>
                                <div className='col-1 px-0 d-flex align-items-center' style={{textAlign: 'center'}}>
                                    <span>圖號</span>
                                </div>
                                <div className='col-2  ps-0'>
                                    <input type="text" id="drawNum" className="form-control" aria-describedby="passwordHelpInline"
                                    onChange={handleInputChange}/>
                                </div>
                                <div className='col-1 px-0 d-flex align-items-center' style={{textAlign: 'center'}}>
                                    <span>項次</span>
                                </div>
                                <div className='col-2  ps-0'>
                                    <input type="text" id="itemNum" className="form-control" aria-describedby="passwordHelpInline"
                                    onChange={handleInputChange}/>
                                </div>
                            </div>
                            <div className='row mb-3'>
                                <div className='col-1 px-0 d-flex align-items-center' style={{textAlign: 'center'}}>
                                    <span>物品名</span>
                                </div>
                                <div className='col-2 ps-0'>
                                    <input type="text" id="itemName" className="form-control" aria-describedby="passwordHelpInline"
                                    onChange={handleInputChange}/>
                                </div>
                                <div className='col-1 px-0 d-flex align-items-center' style={{textAlign: 'center'}}>
                                    <span>單位</span>
                                </div>
                                <div className='col-2  ps-0'>
                                    <input type="text" id="unit" className="form-control" aria-describedby="passwordHelpInline"
                                    onChange={handleInputChange}/>
                                </div>
                                <div className='col-1 px-0 d-flex align-items-center' style={{textAlign: 'center'}}>
                                    <span>訂單數量</span>
                                </div>
                                <div className='col-2  ps-0'>
                                    <input type="text" id="orderAmount" className="form-control" aria-describedby="passwordHelpInline"
                                    onChange={handleInputChange}/>
                                </div>
                                <div className='col-1 px-0 d-flex align-items-center' style={{textAlign: 'center'}}>
                                    <span>訂購單價</span>
                                </div>
                                <div className='col-2  ps-0'>
                                    <input type="text" id="price" className="form-control" aria-describedby="passwordHelpInline"
                                    onChange={handleInputChange}/>
                                </div>
                            </div>
                            <div className='row mb-3'>
                                <div className='col-1 px-0 d-flex align-items-center' style={{textAlign: 'center'}}>
                                    <span>客戶納期</span>
                                </div>
                                <div className='col-2 ps-0'>
                                    <input type="text" id="clientDate" className="form-control" aria-describedby="passwordHelpInline"
                                    onChange={handleInputChange}/>
                                </div>
                                <div className='col-1 px-0 d-flex align-items-center' style={{textAlign: 'center'}}>
                                    <span>承製公司</span>
                                </div>
                                <div className='col-2 ps-0'>
                                    <select className="form-select" id="company" value={selectCom} onChange={setSelectCom}>                               
                                        <option value='福蒙'>
                                        福蒙
                                        </option>
                                        <option value='華辰'>
                                        華辰
                                        </option>                                                         
                                    </select>   
                                </div>
                                 
                            </div>
                            <div className='row'>
                                <div className='col-12 d-flex justify-content-center'>
                                    <button type="submit" className="btn btn-dark">提交</button>
                                </div>
                            </div>
                        </div>
                    </form>
    )
}

